import { RegisterItem } from '../decorators/snitem-factory-decorator';
import { CNItem } from './cnitem';

@RegisterItem()
export class CNDrugIngredient extends CNItem {

    constructor(itemid: number = 0) {
        super(itemid);
        this.key = 'SNItem.CNItem.CNDrugIngredient';
    }

    get name() {
        return this.getProperty('fr');
    }

    public clone(): any {
        return new CNDrugIngredient();
    }
}
